import type { TransactionItemDetail } from 'models';
import { Card } from 'ui';
import { TransactionViewBasedOnUser } from '../../components';

type P = {
  donorsPayment: TransactionItemDetail[];
  title: string;
};

const DonorsHorizontalCard = ({ donorsPayment, title }: P) => (
  <Card.HorizontalScroll
    items={donorsPayment.map((donor, index) => ({
      children: <TransactionViewBasedOnUser transaction={donor} />,
      key: `${donor.id}_${index}`,
    }))}
    title={title}
  />
);

export default DonorsHorizontalCard;
